export const MAX_MEETING_TITLE_LENGTH = 50;
